<base-index-page
  [config]="baseIndexPageConfig"
  [service]="deleteService"
  [idKey]="'websiteId'">

  <regulator-context-box [items]="contextItems" (back)="goBack()" />

</base-index-page>

<ng-template #websiteModal>
  <regulator-website-form
    [regulatorId]="regulatorId"
    [website]="editingWebsite"
    [defaultClientId]="clientId"
    (saved)="onWebsiteSaved()"
    (cancelled)="closeWebsiteForm()" />
</ng-template>
